import { createSelector } from 'reselect';
import selectVisiblePriceTypesByTicketType from './selectVisiblePriceTypesByTicketType';
import getDefaultPriceType from '%evp_ticket_frontend/js/redux/currentEvent/service/getDefaultPriceType';

export default createSelector(
    selectVisiblePriceTypesByTicketType,
    priceTypes => getDefaultPriceType(priceTypes),
);
